export default __webpack_public_path__ + "static/media/logo_pif_liverpool.b222c094.png";